import { Project } from '@/types';
import appStateUpdator from '@/store/AppStateUpdator';

const currentProjectInfoService = {
    saveCurrentProjectStore(project: Project) {
        appStateUpdator.updateCurrentProject(project);
    },
    deleteCurrentProjectStore() {
        appStateUpdator.deleteCurrentProject();
    },
    getCurrentProjectStore() {
        return appStateUpdator.getCurrentProjectStore();
    }
};

export default currentProjectInfoService;
